import React from 'react'
import PropTypes from 'prop-types'

import Col from 'component/utils/Col'
import Form from 'component/utils/Form'
import Row from 'component/utils/Row'

import CheckboxAltChecked from 'images/checkbox-alt-checked.svg'
import CheckboxAltUnchecked from 'images/checkbox-alt-unchecked.svg'

const FIELDS = ['idSourceDepositList', 'idDestinationDepositList']

const SideFilterForm = ({
  depositList,
  fields,
  handleSideFilterElementChange,
  setValueToField,
  sideFilterVisible,
  submit,
  translate,
  values,
}) => {
  const renderOptions = (idDepositList, field, id) => {
    const renderOption = (deposit) => {
      const { idDeposit } = deposit

      const currentValue = values[field]

      const checked = idDepositList.some((depositId) => depositId === idDeposit)

      return (
        <label
          key={idDeposit}
          onClick={() =>
            setValueToField(
              fields[field].input.name,
              checked
                ? currentValue.filter((i) => i !== idDeposit)
                : [...currentValue, idDeposit]
            )
          }
          style={{ display: 'block', margin: '.5rem auto' }}
        >
          <img
            src={checked ? CheckboxAltChecked : CheckboxAltUnchecked}
            className='margin-right'
          />
          {`${deposit.idDeposit} - ${deposit.dsDeposit}`}
        </label>
      )
    }

    return (
      <>
        <strong style={{ display: 'block', margin: '1rem auto' }}>
          {translate(`stockTransfer.missionBlock.${id}`)}
        </strong>
        {depositList.map(renderOption)}
      </>
    )
  }

  return (
    <div
      className='filter-adjustment side-filter'
      ref={handleSideFilterElementChange}
      style={{
        display: sideFilterVisible ? 'block' : 'none',
        height: '500px',
        width: '275px',
      }}
    >
      {renderOptions(
        values.idSourceDepositList,
        'idSourceDepositList',
        'source'
      )}
      {renderOptions(
        values.idDestinationDepositList,
        'idDestinationDepositList',
        'destination'
      )}
      <Row>
        <Col xs={12} className='margin-bottom margin-top-double'>
          <button
            className='button button-primary button-full'
            onClick={() => submit(values)}
            type='button'
          >
            {translate('filter_button_label')}
          </button>
        </Col>
      </Row>
    </div>
  )
}

SideFilterForm.propTypes = {
  depositList: PropTypes.array.isRequired,
  fields: PropTypes.object.isRequired,
  handleSideFilterElementChange: PropTypes.func.isRequired,
  setValueToField: PropTypes.func.isRequired,
  sideFilterVisible: PropTypes.bool.isRequired,
  submit: PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
}

export default Form({ fields: FIELDS })(SideFilterForm)

export { SideFilterForm }
